const DATA_PRODS = [
  {
    id: "1",
    sku: "LBN3465WHITE",
    title: "Lebron 13",
    description:
      "In 2016, the Nike LeBron 13 performance basketball sneaker launched alongside other signature player styles in the “Easter” collection. The colorway rings true to the holiday with a white and silver base that is flanked with pastels and colorful egg-dye prints. Pastel tones hit the Swoosh, tongue branding, and liner of the Nike LeBron 13 for a vibrant look. Color continues on the speckled midsole, toe tip, and partially translucent outsole. So we don’t forget its place in the King James lineup, a colorful 13 is seen on the tongue.",
    image_url: "/img/products/nike-lebron-13-white.png",
    color: "white",
    categorySlug: "Men",
    price: 300,
    qty: 100,
    material: "leather",
    brand_id: 1,
    type_id: 1,
    user_id: 5,
    brandSlug: "Nike",
    brand: "Nike",
    category: "Men",
    slug: "lebron-13",
    size: [
      4, 4.5, 5, 5.5, 6, 6.5, 7, 7.5, 8, 8.5, 9, 9.5, 10, 10.5, 11, 11.5, 12,
      12.5,
    ],
  },
  {
    id: "2",
    sku: "AIRMX453464GRN",
    description:
      "The 2020 Nike Air Max 95 retro is as OG as its 1995 debut. The original design was based on the human body, specifically the ribcage. Keeping up with the ribcage inspiration, the upper features its quintessential ripple makeup, stacking suede in a gradient pattern. Pops of neon green appear throughout from the air bubbles to the miniature Swoosh logo on the ankle. Reflective detailing is featured on the heel and tongue, making this a true OG return.",
    title: "OG Neon",
    categorySlug: "Men",
    image_url: "/img/products/nike-airmax95-og-green.png",
    color: "green",
    price: 202,
    qty: 100,
    material: "leather",
    type_id: 2,
    user_id: 5,
    brandSlug: "Nike",
    category: "Men",
    slug: "og-neon",
    size: [
      4, 4.5, 5, 5.5, 6, 6.5, 7, 7.5, 8, 8.5, 9, 9.5, 10, 10.5, 11, 11.5, 12,
      12.5,
    ],
  },
  {
    id: "3",
    sku: "JRDN98098RD",
    title: "Retro High OG 'GYM Red'",
    categorySlug: "Men",
    description:
      "Giving rise to sneaker culture back in 1985, the Air Jordan 1 Retro High OG represents a paradigm shift in the way that we relate to footwear. This 'Gym Red' reissue—launched in June 2019—remixes an iconic color scheme on its leather upper. Bold lateral Swooshes ignite a sense of sport prestige, while Wings and Jumpman logos reflect hoops heritage. The classic midsole and outsole combination endorses the distinct court inspiration below.",
    image_url: "/img/products/jordan-1-retrohighog-red.png",
    color: "Red",
    price: 200,
    qty: 100,
    material: "leather",
    brand_id: 5,
    type_id: 1,
    user_id: 5,
    brand: "Jordan",
    brandSlug: "Jordan",
    category: "Men",
    size: [8, 8.5, 9, 9.5, 10, 12, 12.5],
  },
  {
    id: "4",
    sku: "JRDN377745BLE",
    title: "Retro Low BG",
    categorySlug: "Men",
    description:
      "Released in April of 2017, the Air Jordan 11 Retro Low ‘UNC’ is based on the 2001 Air Jordan 11 Retro Low ‘Columbia’ that dropped alongside the Air Jordan 11 Retro Low ‘Cherry.’ The design combines a North Carolina Tar Heels-inspired white mesh upper with university blue leather overlays, and an ice blue translucent outsole. Unlike the release in 2001, the 2017 release retails in full family sizes.",
    image_url: "/img/products/jordan-11-retrolowbg-babyblue.png",
    color: "blue",
    price: 250,
    qty: 100,
    material: "leather",
    brand_id: 5,
    type_id: 1,
    user_id: 5,
    brand: "Jordan",
    brandSlug: "Jordan",
    category: "Men",
    size: [
      4, 4.5, 5, 5.5, 6, 6.5, 7, 7.5, 8, 8.5, 9, 9.5, 10, 10.5, 11, 11.5, 12,
      12.5,
    ],
  },
  {
    id: "5",
    sku: "YZY83428GRY",
    description:
      "his inaugural colorway of Kanye West’s Yeezy Wave Runner 700 launched in November 2017, following a public debut earlier in the year as part of the Yeezy Season 5 runway show. The sneaker’s retro-inspired lines worked in tandem with a chunky silhouette reminiscent of an earlier era. A mesh base is finished in grey on the quarter panels and bright blue and teal on the forefoot. Suede overlays arrive on the toe and heel accented grey leather eyestays. Other details include neon green laces, a bulky white midsole, and pops of black and bright orange.",
    title: "Boost 700",
    categorySlug: "Men",
    image_url: "/img/products/adidas-yeezy-boost700-grey.png",
    color: "Grey",
    price: 415,
    qty: 100,
    material: "Suede",
    brand_id: 2,
    type_id: 4,
    user_id: 5,
    brand: "Adidas",
    brandSlug: "Adidas",
    category: "Men",
    size: [8, 8.5, 9, 9.5, 10, 10.5, 11, 11.5, 12, 12.5],
  },
  {
    id: "6",
    sku: "JMS384293PNDBLK",
    title: "Panda Bear",
    slug: "panda-bear",
    description:
      "Fashion designer Jeremy Scott partnered with adidas on his very limited JS Panda Bear ‘Jeremy Scott.’ The shoe’s black and white plush upper replaces the tongue with a large panda bear head wearing an adidas headband. The top eyelets feature arms, while the design is finished with a black sole with white contrast stitching.",
    image_url: "/img/products/adidas-jeremyscott-pandabear-black.png",
    color: "Black",
    price: 550,
    qty: 100,
    material: "Fur",
    brand_id: 2,
    type_id: 6,
    user_id: 5,
    brand: "Adidas",
    brandSlug: "Adidas",
    category: "Men",
    categorySlug: "Men",
    size: [11, 11.5],
  },
  {
    id: "7",
    sku: "136027",
    title: "Retro 'Grape' 2013",
    brand: "Jordan",
    brandSlug: "Jordan",
    description:
      "The Air Jordan 5 Retro ‘Grape’ returned to Jordan Brand retailers in May of 2013. One of the original four colorways released in 1990, the sneaker was worn by MJ during a Wheaties box cover shoot and by Will Smith on the Fresh Prince of Bel-Air. Previously retro’d in 2006, the design combines a White leather upper with Black, New Emerald, and Grape accents on a translucent blue outsole.",
    image_url: "/img/products/jordan-5-grape.png",
    color: "purple",
    price: 330,
    qty: 100,
    material: "leather",
    brand_id: 1,
    type_id: 1,
    user_id: 5,
    category: "Men",
    categorySlug: "Men",
    size: [
      4, 4.5, 5, 5.5, 6, 6.5, 7, 7.5, 8, 8.5, 9, 9.5, 10, 10.5, 11, 11.5, 12,
      12.5,
    ],
  },
  {
    id: "8",
    sku: "136027",
    title: "High OG 'UNC To Chicago'",
    description:
      "The Wmns Air Jordan 1 High OG 'UNC To Chicago' dips Michael Jordan's iconic first signature sneaker in a mix of two popular colorways. It features hues from MJ's college and first pro team, the University of North Carolina Tar Heels and the Chicago Bulls. Dressed in black, Dark Powder Blue and Gym Red, the women's shoe comes with a premium upper and displays both Jordan and Nike branding. Finishing the look are toe box perforations and a rubber outsole with a pivot point tread pattern.",
    brand: "Jordan",
    brandSlug: "Jordan",
    image_url: "/img/products/wmns-a1-high-og.png",
    color: "Multi-Color",
    price: 124,
    qty: 100,
    material: "leather",
    brand_id: 1,
    type_id: 1,
    user_id: 5,
    category: "Women",
    size: [
      4, 4.5, 5, 5.5, 6, 6.5, 7, 7.5, 8, 8.5, 9, 9.5, 10, 10.5, 11, 11.5, 12,
      12.5,
    ],
  },
  {
    id: "9",
    sku: "DJ1034",
    title: "Air Jordan 14 Retro Low SP 'Fortune'",
    brand: "Jordan",
    brandSlug: "Jordan",
    description:
      "The Aleali May x women’s Air Jordan 14 Retro Low SP ‘Fortune’ reunites Jordan Brand with the LA-based model and stylist for a fifth collaboration. Inspired by May’s personal heritage and cultural experiences, the low-top is treated to a luxe makeover, highlighted by a tan suede upper with contrasting hits of black on the collar and tongue. The midsole is enlivened with jade accents and a metallic gold shank plate, both of which nod to May’s first ever piece of jewelry — a bracelet that was gifted by her grandmother.",
    image_url: "/img/products/Air-Jordan-14-Retro-Low-SP-Fortune.png",
    color: "Tan",
    price: 330,
    qty: 100,
    material: "Suede",
    brand_id: 1,
    type_id: 1,
    user_id: 5,
    categorySlug: "Women",
    size: [7, 7.5, 8, 8.5, 9, 9.5, 10, 10.5, 11],
  },
  {
    id: "10",
    sku: "CV9388",
    title: "Off-White x Wmns Air Jordan 4 SP 'Sail'",
    brand: "Off-White",
    brandSlug: "Off-White",
    description:
      "The Aleali May x women’s Air Jordan 14 Retro Low SP ‘Fortune’ reunites Jordan Brand with the LA-based model and stylist for a fifth collaboration. Inspired by May’s personal heritage and cultural experiences, the low-top is treated to a luxe makeover, highlighted by a tan suede upper with contrasting hits of black on the collar and tongue. The midsole is enlivened with jade accents and a metallic gold shank plate, both of which nod to May’s first ever piece of jewelry — a bracelet that was gifted by her grandmother.",
    image_url: "/img/products/Sail.png",
    color: "Tan",
    price: 1242,
    qty: 100,
    material: "leather",
    brand_id: 1,
    type_id: 1,
    user_id: 5,
    categorySlug: "Women",
    size: [
      4, 4.5, 5, 5.5, 6, 6.5, 7, 7.5, 8, 8.5, 9, 9.5, 10, 10.5, 11, 11.5, 12,
      12.5,
    ],
  },
  {
    id: "11",
    sku: "AV3914",
    title: "Retro NRG 'Singles Day'",
    description:
      "The women’s Air Jordan 4 Retro NRG ‘Singles Day’ celebrates the holiday with a leather build that’s entirely finished in Fire Red. In addition to a gum rubber outsole, the shoe features contrasting pops of black on the tongue tag, eyelets and Jumpman logo on the heel. The red coating on the upper is designed to eventually wear away, revealing an ornamental design underneath.",
    image_url: "/img/products/singles-day.png",
    color: "Red",
    price: 172,
    qty: 100,
    material: "leather",
    brand_id: 2,
    type_id: 4,
    user_id: 5,
    category: "Women",
    brandSlug: "Jordan",
    brand: "Jordan",
    categorySlug: "Women",
    size: [4, 4.5, 5, 5.5, 6, 6.5, 7, 7.5, 8, 8.5, 9, 9.5, 10, 10.5],
  },
  {
    id: "12",
    sku: "JMS384293PNDBLK",
    title: "OVO Black",
    image_url: "/img/products/ovo-black-2016.png",
    color: "Black",
    price: 550,
    qty: 100,
    material: "Leather",
    brand_id: 2,
    type_id: 6,
    user_id: 5,
    brand: "Jordan",
    brandSlug: "Jordan",
    category: "Men",
    slug: "ovo-jordan",
    categorySlug: "Men",
    size: [
      4, 4.5, 5, 5.5, 6, 6.5, 7, 7.5, 8, 8.5, 9, 9.5, 10, 10.5, 11, 11.5, 12,
      12.5,
    ],
  },
  // {
  //   _id: "13",
  //   sku: "136027",
  //   title: "Air Jordan 5 Retro 'Grape' 2013",
  //   brand: "Air Jordan",
  //   description:
  //     "The Air Jordan 5 Retro ‘Grape’ returned to Jordan Brand retailers in May of 2013. One of the original four colorways released in 1990, the sneaker was worn by MJ during a Wheaties box cover shoot and by Will Smith on the Fresh Prince of Bel-Air. Previously retro’d in 2006, the design combines a White leather upper with Black, New Emerald, and Grape accents on a translucent blue outsole.",
  //   image_url: "/img/products/jordan-5-grape.png",
  //   color: "white",
  //   price: 330,
  //   qty: 100,
  //   material: "leather",
  //   brand_id: 1,
  //   type_id: 1,
  //   user_id: 5,
  // },
  // {
  //   _id: "14",
  //   sku: "136027",
  //   title: "Air Jordan 5 Retro 'Grape' 2013",
  //   brand: "Air Jordan",
  //   description:
  //     "The Air Jordan 5 Retro ‘Grape’ returned to Jordan Brand retailers in May of 2013. One of the original four colorways released in 1990, the sneaker was worn by MJ during a Wheaties box cover shoot and by Will Smith on the Fresh Prince of Bel-Air. Previously retro’d in 2006, the design combines a White leather upper with Black, New Emerald, and Grape accents on a translucent blue outsole.",
  //   image_url: "/img/products/jordan-5-grape.png",
  //   color: "white",
  //   price: 330,
  //   qty: 100,
  //   material: "leather",
  //   brand_id: 1,
  //   type_id: 1,
  //   user_id: 5,
  // },
  // {
  //   _id: "15",
  //   sku: "136027",
  //   title: "Air Jordan 5 Retro 'Grape' 2013",
  //   brand: "Air Jordan",
  //   description:
  //     "The Air Jordan 5 Retro ‘Grape’ returned to Jordan Brand retailers in May of 2013. One of the original four colorways released in 1990, the sneaker was worn by MJ during a Wheaties box cover shoot and by Will Smith on the Fresh Prince of Bel-Air. Previously retro’d in 2006, the design combines a White leather upper with Black, New Emerald, and Grape accents on a translucent blue outsole.",
  //   image_url: "/img/products/jordan-5-grape.png",
  //   color: "white",
  //   price: 330,
  //   qty: 100,
  //   material: "leather",
  //   brand_id: 1,
  //   type_id: 1,
  //   user_id: 5,
  // },
  // {
  //   _id: "16",
  //   sku: "136027",
  //   title: "Air Jordan 5 Retro 'Grape' 2013",
  //   brand: "Air Jordan",
  //   description:
  //     "The Air Jordan 5 Retro ‘Grape’ returned to Jordan Brand retailers in May of 2013. One of the original four colorways released in 1990, the sneaker was worn by MJ during a Wheaties box cover shoot and by Will Smith on the Fresh Prince of Bel-Air. Previously retro’d in 2006, the design combines a White leather upper with Black, New Emerald, and Grape accents on a translucent blue outsole.",
  //   image_url: "/img/products/jordan-5-grape.png",
  //   color: "white",
  //   price: 330,
  //   qty: 100,
  //   material: "leather",
  //   brand_id: 1,
  //   type_id: 1,
  //   user_id: 5,
  // },
  // {
  //   _id: "17",
  //   sku: "JRDN377745BLE",
  //   title: "Retro Low BG",
  //   image_url: "/img/products/jordan-11-retrolowbg-babyblue.png",
  //   color: "blue",
  //   price: 250,
  //   qty: 100,
  //   material: "leather",
  //   brand_id: 5,
  //   type_id: 1,
  //   user_id: 5,
  //   brand: "Jordan",
  // },
  // {
  //   _id: "18",
  //   sku: "LBN3465WHITE",
  //   title: "Lebron 13",
  //   description:
  //     "In 2016, the Nike LeBron 13 performance basketball sneaker launched alongside other signature player styles in the “Easter” collection. The colorway rings true to the holiday with a white and silver base that is flanked with pastels and colorful egg-dye prints. Pastel tones hit the Swoosh, tongue branding, and liner of the Nike LeBron 13 for a vibrant look. Color continues on the speckled midsole, toe tip, and partially translucent outsole. So we don’t forget its place in the King James lineup, a colorful 13 is seen on the tongue.",
  //   image_url: "/img/products/nike-lebron-13-white.png",
  //   color: "white",
  //   price: 300,
  //   qty: 100,
  //   material: "leather",
  //   brand_id: 1,
  //   type_id: 1,
  //   user_id: 5,
  //   brand: "Nike",
  // },
  // {
  //   _id: "19",
  //   sku: "AIRMX453464GRN",
  //   title: "Evergreen",
  //   image_url: "/img/products/nike-airmax95-og-green.png",
  //   color: "green",
  //   price: 400,
  //   qty: 100,
  //   material: "leather",
  //   brand_id: 1,
  //   type_id: 2,
  //   user_id: 5,
  //   brand: "Nike",
  // },
  // {
  //   _id: "20",
  //   sku: "JRDN98098RD",
  //   title: "Retro High OG",
  //   image_url: "/img/products/jordan-1-retrohighog-red.png",
  //   color: "Red",
  //   price: 200,
  //   qty: 100,
  //   material: "leather",
  //   brand_id: 5,
  //   type_id: 1,
  //   user_id: 5,
  //   brand: "Jordan",
  // },
  // {
  //   _id: "21",
  //   sku: "JRDN377745BLE",
  //   title: "Retro Low BG",
  //   image_url: "/img/products/jordan-11-retrolowbg-babyblue.png",
  //   color: "blue",
  //   price: 250,
  //   qty: 100,
  //   material: "leather",
  //   brand_id: 5,
  //   type_id: 1,
  //   user_id: 5,
  //   brand: "Jordan",
  // },
];
const getAllProducts = () => DATA_PRODS;

const getProducts = (count) => {
  const max = DATA_PRODS.length - count;
  const min = 0;
  const start = Math.floor(Math.random() * (max - min) + min);
  return DATA_PRODS.slice(start, start + count);
};

const getProductBySlug = (id) => DATA_PRODS.find((e) => e.id === id);

const productData = {
  getAllProducts,
  getProducts,
  getProductBySlug,
};

export default productData;

// const getAllProducts = () => products;

// const getProducts = (count) => {
//   const max = products.length - count;
//   const min = 0;
//   const start = Math.floor(Math.random() * (max - min) + min);
//   return products.slice(start, start + count);
// };

// const getProductBySlug = (slug) => products.find((e) => e.slug === slug);

// const productData = {
//   getAllProducts,
//   getProducts,
//   getProductBySlug,
// };
// export default productData;

// export default DATA_PRODS;
